const MonitorStatusEnum = {
    0: "Beklemede",
    1: "Pasif",
    '-1': "Hata",
    2: "İz Olmuş",
    3: "Vekaletsiz",
    4: "ByPass",
    5: "OK",
    6: "Diğer",
    7: "Hatalı Şifre",
    8: "Captcha Sorunu",
    '-99': "Sistemsel Hata",
};

export default MonitorStatusEnum;